import React, { useMemo, useLayoutEffect } from 'react';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { HelmetProvider } from 'react-helmet-async';
import { renderRoutes } from 'react-router-config';
import './i18n';
import { Context as ConfigContext } from './Config';
import { Provider as ScriptProvider } from './componentsInternal/InnerHtmlProvider';
import { getInitialData } from './utils/globals';
import { setupStore } from './reduxStore';
import { setupAnalytics, setAnalyticsIsEnabled } from './analytics';
import { setupBugTracking } from './utils/bugTracking';
import { setup as setupClientApi } from './clientApi';
import { createHistory } from './utils/createHistory';
import AppRoutes, { getRoutes } from './componentsInternal/Routes';
ssoRedirectCheck();
setupBugTracking();
setupAnalytics();
setupClientApi();
const App = ({ config }) => {
    const history = useMemo(() => createHistory(config), [config]);
    const store = useMemo(() => setupStore({
        initialPageData: getInitialData(),
        path: window.location.pathname,
        config,
    }), [config]);
    useLayoutEffect(() => {
        setAnalyticsIsEnabled(true);
    }, []);
    const routes = getRoutes(config);
    return (React.createElement(React.StrictMode, null,
        React.createElement(ConfigContext.Provider, { value: config },
            React.createElement(HelmetProvider, null,
                React.createElement(Provider, { store: store },
                    React.createElement(Router, { history: history },
                        React.createElement(QueryParamProvider, { ReactRouterRoute: Route },
                            React.createElement(ScriptProvider, null,
                                React.createElement(AppRoutes, { routes: routes }, renderRoutes(routes))))))))));
};
App.displayName = 'App';
export default App;
// Check for OIDC format SSO token
function ssoRedirectCheck() {
    if (window.location.href.includes('#') &&
        window.location.href.includes('id_token')) {
        window.location.href = `${window.location.protocol}//${window.location.hostname}/sso/check?${window.location.href
            .split('#')[1]
            .replace('id_token', 'jwt')}`;
    }
}
//# sourceMappingURL=App.js.map